const DETAIL_ROW_COMPARE_KEYS = [
  'id',
  'row_id',
  'row_order',
  'position',
  'is_placeholder',
  '_isDraft',
  'item',
  'account_number',
  'currency',
  'quantity',
  'quantity_expression',
  'unit',
  'rate',
  'rate_expression',
  'multiplier',
  'multiplier_expression',
  'multiplier_unit',
  'ot1_quantity',
  'ot2_quantity',
  'ot3_quantity',
  'ot4_quantity',
  'item_total',
  'fringe_total',
  'tags',
  'column_total',
  'column_total_primary_currency',
  'actual',
  'estimate_to_complete_override',
  'effective_estimate_to_complete',
  'comment',
  'updated_on',
];

const normalizeComparableValue = value => {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value) || typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};

export const detailRowsAreEquivalent = (currentRows = [], nextRows = []) => {
  if (currentRows.length !== nextRows.length) return false;

  return currentRows.every((currentRow, index) => {
    const nextRow = nextRows[index];
    if (!currentRow || !nextRow) return currentRow === nextRow;

    return (
      DETAIL_ROW_COMPARE_KEYS.every(
        key =>
          normalizeComparableValue(currentRow[key]) ===
          normalizeComparableValue(nextRow[key])
      ) &&
      normalizeComparableValue(currentRow.fringe) ===
        normalizeComparableValue(nextRow.fringe) &&
      normalizeComparableValue(currentRow.tags) ===
        normalizeComparableValue(nextRow.tags)
    );
  });
};
